export type ValuesQuestion = {
  value: string
  question: string
}

export const questions: ValuesQuestion[] = [
  { value: 'Achievement', question: 'Challenging myself to achieve' },
  { value: 'Achievement', question: 'Improving my performance' },
  { value: 'Achievement', question: 'Working hard to do better' },

  { value: 'Belonging', question: 'Being liked by others' },
  { value: 'Belonging', question: 'Being accepted by others' },
  { value: 'Belonging', question: 'Feeling as though I belong' },

  {
    value: 'Concern for The Environment',
    question: 'Protecting the environment',
  },
  {
    value: 'Concern for The Environment',
    question: 'Taking care of the environment',
  },
  {
    value: 'Concern for The Environment',
    question: 'Appreciating the beauty of nature',
  },

  {
    value: 'Concern for Others',
    question: 'Being sensitive to others’ needs',
  },
  { value: 'Concern for Others', question: 'Helping others' },
  {
    value: 'Concern for Others',
    question: 'Being concerned about the rights of others',
  },

  { value: 'Creativity', question: 'Coming up with new ideas' },
  { value: 'Creativity', question: 'Creating new things or ideas' },
  { value: 'Creativity', question: 'Discovering new things or ideas' },

  { value: 'Financial Prosperity', question: 'Having financial success' },
  { value: 'Financial Prosperity', question: 'Making money' },
  {
    value: 'Financial Prosperity',
    question: 'Being wealthy (having lots of money, land or livestock)',
  },

  { value: 'Health and Activity', question: 'Taking care of my body' },
  { value: 'Health and Activity', question: 'Being in good physical shape' },
  {
    value: 'Health and Activity',
    question: 'Being strong or good in a sport (being athletic)',
  },

  { value: 'Humility', question: 'Downplaying compliments or praise' },
  { value: 'Humility', question: 'Being quiet about my success' },
  { value: 'Humility', question: 'Avoid credit for my accomplishments' },

  {
    value: 'Independence',
    question: 'Being independent (doing things I want to do)',
  },
  { value: 'Independence', question: 'Giving my opinion' },
  { value: 'Independence', question: 'Having control over my time' },

  {
    value: 'Loyalty to Family or Group',
    question: 'Accepting my place in my family or group',
  },
  {
    value: 'Loyalty to Family or Group',
    question: 'Respecting the traditions of my family or group',
  },
  {
    value: 'Loyalty to Family or Group',
    question: 'Making decisions with my family or group in mind',
  },

  { value: 'Privacy', question: 'Having time to myself' },
  { value: 'Privacy', question: 'Having quiet time to think' },
  { value: 'Privacy', question: 'Having a private place to go' },

  { value: 'Responsibility', question: 'Being reliable' },
  { value: 'Responsibility', question: 'Being trustworthy' },
  { value: 'Responsibility', question: 'Meeting my obligations' },

  {
    value: 'Scientific Understanding',
    question: 'Using science for progress',
  },
  {
    value: 'Scientific Understanding',
    question: 'Knowing things about science',
  },
  { value: 'Scientific Understanding', question: 'Knowing about math' },

  { value: 'Spirituality', question: 'Believing in a higher power' },
  {
    value: 'Spirituality',
    question: 'Believing that there is something greater than ourselves',
  },
  {
    value: 'Spirituality',
    question: 'Living in harmony with my spiritual beliefs',
  },
]
